import {createFileRoute} from '@tanstack/react-router';
import {LoanAccountPPICloseInfoPage} from '../../../../../../../features/loans/pages/LoanAccountPPIClosePage/LoanAccountPPICloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/loans/$accountId/ppi/close/',
)({
  component: LoanAccountPPICloseInfoPage,
});
